import { Button, Flex, Stack, Heading, Text, Link } from "@chakra-ui/react";
import { Input } from "../../components/Forms/Input";
import { useAuth } from "../../contexts/AuthContext";
import { useState } from "react";
import { Resolver, useForm } from "react-hook-form";
import { showToast } from "../../utils";

type FormValues = {
  email: string;
  pass: string;
};

const resolver: Resolver<FormValues> = async (values) => {
  return {
    values: values.email ? values : {},
    errors: !values.email
      ? {
          email: {
            type: "required",
            message: "E-mail é um campo obrigatório.",
          },
          pass: {
            type: "required",
            message: "Senha é um campo obrigatório.",
          },
        }
      : {},
  };
};

export const Login: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver });
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);

  const onSubmit = handleSubmit(async (data: any) => {
    setLoading(true);
    try {
      await signIn(data);
    } catch (error: any) {
      error?.response?.data?.errors?.map((error:any) => (
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      ));
    }
    setLoading(false);
  });

  return (
    <Flex w="100vw" h="100vh">
      <Flex 
        maxW="780px" 
        w="100%" 
        align="center" 
        justify="center"
      >
        <Flex
          as="form"
          direction="column"
          justify="center"
          h="100vh"
          maxW={380}
          w="100%"
          onSubmit={onSubmit}
        >
            <Stack spacing="6" w="100%">
                <Heading fontSize="2rem">Login</Heading>
                <Input
                    label="E-mail"
                    type="text"
                    name="email"
                    placeholder="Insira seu e-mail"
                    className="mb-3"
                    register={{ ...register("email") }}
                    errors={errors?.email}
                    aria-label="Insira seu e-mail"
                    aria-invalid={errors.email ? "true" : "false"}
                    fontSize="1rem"
                />

                <Input
                    label="Senha"
                    type="password"
                    name="pass"
                    placeholder="Insira sua senha"
                    className="mb-4"
                    register={{ ...register("pass") }}
                    errors={errors?.pass}
                    aria-label="Insira sua senha"
                    aria-invalid={errors.pass ? "true" : "false"}
                    fontSize="1rem"
                />
                <Link
                  href="/redefinir-senha"
                  textAlign="right"
                  textDecoration="underline"
                >
                  Esqueci a senha
                </Link>
                <Button
                    isLoading={loading}
                    maxW={75}
                    type="submit"
                    size="md"
                    color="white"
                    variant="login"
                    fontSize="1rem"
                    py="1rem"
                >
                    Entrar
                </Button>
            </Stack>
            
        </Flex>
      </Flex>

      <Flex 
        flex="1" 
        bg="gray.800" 
        align="center" 
        justifyContent="center" 
      >
          <Stack maxW="360px" w="100%">
                <Flex position="relative" maxW={280}>
                    <img
                        alt={`Logo do ${process.env.REACT_APP_APPLICATION_NAME}`}
                        src={`logo-${process.env.REACT_APP_APPLICATION_NAME}.svg`}
                        width="100%"
                        height={40}
                    />
                    <Text 
                        position="absolute"
                        right="-32%"
                        bottom="40%"
                        color="success"
                        fontSize={["24px", "28px"]}
                    >
                        admin
                    </Text>
                </Flex>
                <Text 
                    color="white"
                    lineHeight="28px"
                    fontSize="20px"
                >
                    Saúde financeira para empresas que fazem acontecer.
                </Text>
            </Stack>
      </Flex>
    </Flex>
  );
};